import _loadView from 'rlink-router/actions/_loadView';
import hideTooltip from 'rlink-tooltips/actions/hideTooltip';

/**
 * Open up a new modal view
 *
 * @param {BuildContext} options.buildContext The current build
 *   context. Required if view is also given.
 * @param {string} options.view A view function name. (mutually
 *  exclusive with `content`).
 * @param {object} options.params Params object for view
 *   function. (mutually exclusive with `content`).
 * @param {PropType.node} options.content React renderable
 *   content. (mutually exclusive with `view` and `params`).
 * @param {boolean} options.replace Should the top-most modal be
 *   replaced instead of being pushed on top of any existing modals?
 * @param {string} options.transition The name of the CSS transition
 *   to use when showing the modal.
 * @param {string} options.returnTransition The name of the CSS
 *   transition to use when closing the modal.
 * @param {boolean} options.fullscreen Should the modal be considered
 *   fullscreen? Turns off closing by clicking outside of the modal.
 * @param {func} options.onClose Callback function for onCloseModal
 * @param {string[]} options.bindOnCloseToClassNames Array of class names
 *   to bind the onclose event for the modal to. (Solves the can't click overlay problem)
 * @return {Thunk}
 */
export default function openModal ({
  buildContext,
  view,
  params,
  content,
  replace,
  nudgeOffset = 0,
  transition = '',
  returnTransition = '',
  fullscreen = false,
  onClose,
  bindOnCloseToClassNames = [],
}) {
  return async dispatch => {
    if (content === undefined) {
      content = await dispatch(_loadView(buildContext, view, params));
    }
    dispatch(hideTooltip());
    dispatch({
      type: 'MOUNT_MODAL',
      payload: {
        replace,
        nudgeOffset,
        content,
        transition,
        returnTransition,
        fullscreen,
        onClose,
        bindOnCloseToClassNames,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/openModal.js